import { render, staticRenderFns } from "./RegisterNewUser.vue?vue&type=template&id=8c839200&scoped=true"
import script from "./RegisterNewUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterNewUser.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RegisterNewUser.vue?vue&type=style&index=0&id=8c839200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c839200",
  null
  
)

export default component.exports